import { Text } from 'foundations-components/components/Text';
import FreePriceDisplayStyled from '../../../../components/merch-card/price-display/FreePriceDisplayStyled';
import { MerchCardLayoutUI } from '../../../components/MerchCardLayoutUI';
import { useIsInAppAuth } from '../../../hooks/user/useUserInfo';
import { FreeToolsPurchaseMotion } from '../../FreeToolsPurchaseMotion';
import { MerchCardSubheadingContainer } from '../headings-display/MerchCardSubheadingContainer';
import { MerchCardTitleContainer } from '../headings-display/MerchCardTitleContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const FreeToolsMerchCard = ({
  HubDescription,
  Title,
  Features,
  trackingSource,
  columnStart = 1
}) => {
  const isInApp = useIsInAppAuth();
  return /*#__PURE__*/_jsx(MerchCardLayoutUI, {
    "data-test-id": `free-tools-merch-card-${trackingSource}`,
    "data-selenium-id": `free-tools-merch-card-${trackingSource}`,
    columnStart: columnStart,
    Title: /*#__PURE__*/_jsx(MerchCardTitleContainer, {
      Title: Title
    }),
    Subheading: /*#__PURE__*/_jsx(MerchCardSubheadingContainer, {
      Subheading: HubDescription
    }),
    Pricing: /*#__PURE__*/_jsx(Text, {
      as: "div",
      typography: "heading-400",
      children: /*#__PURE__*/_jsx(FreePriceDisplayStyled, {})
    }),
    CTAs: /*#__PURE__*/_jsx(FreeToolsPurchaseMotion, {
      trackingSource: trackingSource,
      sourceId: "free-tools-merch-card",
      isInApp: isInApp
    }),
    Features: Features
  });
};